import appStore from 'store';
import api from './api';
import { PAGINATION } from 'common/config';

const store = {
  namespaced: true,
  state: {
    coinList: [],
    pagination: PAGINATION,
    totalCount: 0
  },
  getters: {},
  mutations: {
    setCoinList(state, payload) {
      state.totalCount = payload.totalCount;
      state.coinList = payload.list.slice();
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    list({ commit }, query) {
      commit('setPagination', {
        page: query.page,
        size: query.size
      });
      api.getCoinList(query).then(({ data }) => {
        commit('setCoinList', data);
      });
    },
    create(context, data) {
      return api.createCoin(data);
    }
  }
};

appStore.registerModule('voteCoinSetting', store);
